import { useState, useCallback } from 'react';
import { apiService, UpdatePostVisibilityRequest } from '@/services/api';
import { useAuth } from '@/contexts/AuthContext';

export const useUpdatePostVisibility = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { user, token } = useAuth();

  const updatePostVisibility = useCallback(async (params: Omit<UpdatePostVisibilityRequest, 'userID'>) => {
    if (!user?.uid) {
      setError('User not authenticated');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const updateData: UpdatePostVisibilityRequest = {
        ...params,
        userID: user.uid,
      };

      const response = await apiService.updatePostVisibility(updateData, token || null);
      
      if (response.statusCode === 200) {
        console.log('Post visibility updated successfully:', response.message);
        return response;
      } else {
        throw new Error(response.message || 'Failed to update post visibility');
      }
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to update post visibility';
      setError(errorMessage);
      console.error('Error updating post visibility:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [user?.uid, token]);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    updatePostVisibility,
    loading,
    error,
    clearError,
  };
};
